module.exports = __webpack_public_path__ + "img/home-works-4.8b228e9e.png";